import axiosService from '../utils/axios';
import { PartnerWallet } from '../types/promo';

export async function getWallet(): Promise<PartnerWallet> {
    const { data } = await axiosService.get<PartnerWallet>('/partner/billing/wallet');
    return data;
}

export async function createTopUpSession(amountCents: number): Promise<{ id: string }> {
    const { data } = await axiosService.post<{ id: string }>('/partner/billing/topup-session', { amountCents });
    return data;
}

export interface ConfirmTopUpResponse {
    success: boolean;
    pending?: boolean;
    idempotent?: boolean;
    wallet?: PartnerWallet | null;
    message?: string;
}

export async function confirmTopUp(sessionId: string): Promise<ConfirmTopUpResponse> {
    const { data } = await axiosService.post<ConfirmTopUpResponse>('/partner/billing/topup/confirm', { sessionId });
    return data;
}

export interface WalletTransaction {
    id: string;
    type: 'stripe_topup' | 'comp_grant' | 'comp_revoke';
    amountCents: number;
    createdAt: string;
    source?: string;
    note?: string;
}

export async function getWalletTransactions(): Promise<WalletTransaction[]> {
    const { data } = await axiosService.get<{ transactions: WalletTransaction[] }>('/partner/billing/transactions');
    return data.transactions;
}
